import React, { useEffect } from "react";
import "./Terms_Conditions.css";
import Common_Title_1 from "../../../../common/common_components/common_title_1/Common_Title_1";
import Pink_Btn from "../../../../common/common_btn/pink_btn/Pink_Btn";
import { AllTermsCondition } from '../../../../../features/admin/footer/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";
const Terms_Conditions = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const terms_condition = useSelector((state) => state.footer.terms_condition);

  // console.log("all_terms_conditionall_terms_condition",terms_condition)

  useEffect(() => {
    dispatch(AllTermsCondition());
  }, [dispatch]);

  return (
    <section className="Terms_Conditions Privacy_Policy">
      <Common_Title_1 subText="Terms & Conditions" />

      {/* <p className=''>{parse(all_terms_condition[0]?.content ||"")}</p> */}
      <p className="">{parse(terms_condition[0]?.content || "")}</p>

      <div className="btn_holder">
        <Pink_Btn btnText={"OK"} onClick={() => { navigate("/settings/menu") }} />
      </div>
    </section>
  );
};

export default Terms_Conditions;
